import React, { useState, useEffect } from 'react';
import { Card, CardContent, Snackbar, Alert, Typography, Box } from '@mui/material';
import { SimpleForm, TextInput, SelectInput, useNotify } from 'react-admin';



const RequestAccessFormGeneral = () => {
    const [userRoles, setUserRoles] = useState([]);
    const [actions, setActions] = useState([]);
    const [application, setApplications] = useState([]);
    const [showNotification, setShowNotification] = useState(false);
    const notify = useNotify();

    useEffect(() => {
        async function fetchData() {
            const userRolesData = await fetchUserRoles();
            setUserRoles(userRolesData);

            const actionsData = await fetchActions();
            setActions(actionsData);

            const applicationsData = await fetchApplications();
            setApplications(applicationsData);
        }

        fetchData();
    }, []);

    const handleSubmit = (values) => {
        console.log(values);
        notify('Request submitted! Thanks for completing the form. We\'ll be in touch soon!', { type: 'success' });
        setShowNotification(true);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>
            <Card style={{ width: '700px' }}>
                <CardContent>
                    <Box display="flex" justifyContent="center" marginBottom="20px">
                        <Typography variant="h5" component="div">
                            Request Access Form
                        </Typography>
                    </Box>

                    <SimpleForm onSubmit={handleSubmit}>
                        <TextInput source="email" label="What is your email address?" fullWidth required />
                        <SelectInput source="application" label="Application you are requesting access for" choices={application} fullWidth required />
                        <TextInput source="requestReason" label="Why are you requesting access?" fullWidth multiline required />
                        <SelectInput source="role" choices={userRoles} label="What role would you want?" fullWidth required />
                    </SimpleForm>
                </CardContent>
            </Card>
            <Snackbar
                open={showNotification}
                autoHideDuration={3000}
                onClose={() => setShowNotification(false)}
            >
                <Alert severity="success">
                    Request submitted! Thanks for completing the form. We'll be in touch soon!
                </Alert>
            </Snackbar>
        </div>
    );
};

export default RequestAccessFormGeneral;


/*
Fields for Admin approving/decliniging  access form 

<SelectInput source="action" label="Actions" choices={actions} optionText="name" optionValue="id" fullWidth required />
<TextInput source="approvalReason" label="Reason for approval or decline" fullWidth multiline required />


*/




// Mock API functions for demonstration purposes
async function fetchUserRoles() {
    return [
        { id: 'admin', name: 'Admin' },
        { id: 'user', name: 'User' },
        { id: 'guest', name: 'Guest' },
    ];
}

async function fetchApplications () {
    return [
        { id: 'UKSPF', name: 'UKSPF' },
        { id: 'Thrive at work', name: 'Thrive at work' },
    ];
}

async function fetchActions() {
    return [
        { id: 'approve', name: 'Approve' },
        { id: 'decline', name: 'Decline' },
    ];
}

